import salesWidgetService from '@/modules/widgets/salesWidget/services/salesWidgetService';

const state = {
  salesWidgetData: null,
  forecastData: null,
};

const getters = {
  salesWidgetData: (state) => state.salesWidgetData,
  forecastData: (state) => state.forecastData,
};

const mutations = {
  setSalesWidgetData(state, data) {
    state.salesWidgetData = data;
  },
  setForecastData(state, data) {
    state.forecastData = data;
  },
};

const actions = {
  async fetchSalesWidgetData({ commit }, { startDate, endDate } = {}) {
    try {
      const response = await salesWidgetService.getSalesWidgetData({ startDate, endDate });
      if (response && response.success) {
        commit('setSalesWidgetData', response.data);
        return true;
      }
      commit('setSalesWidgetData', null);
      return false;
    } catch (error) {
      commit('setSalesWidgetData', null);
      return false;
    }
  },
  async fetchForecastData({ commit }) {
    try {
      const response = await salesWidgetService.getForecastData();
      if (response && response.success) {
        commit('setForecastData', response.data);
        return true;
      }
      commit('setForecastData', null);
      return false;
    } catch (error) {
      commit('setForecastData', null);
      return false;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
